/* ---------------------------------------------------------------------------
   Jackler 7.x site-wide script (MAIN 7.11 Phase 1c, 2026-09-26).
   Loaded once (defer) from layout/theme.liquid. Small jobs (5 added in 7.12 lib):
   1. Card quick-add: when the quick-add sheet opens, the card's "+" rotates
      into an "x" and moves to the sheet's close corner; tapping it closes
      the sheet.
   2. Continuous backdrop: on a product page whose character has a mood
      backdrop, the sale banner and the product area show ONE picture laid
      out in page coordinates, so the banner is a window onto the same image
      and both drift together (styles in assets/jackler-7x.css).
   3. Mobile product gallery: at most 2 photos stack; the rest swipe (1d).
   4. The product page's Request a customization link follows the variant (1e).
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  /* 1. Quick-add "+" -> "x" ------------------------------------------------ */
  var lastTrigger = null;
  var xBtn = null;
  var sheetObserver = null;

  function hideX() {
    if (xBtn) { xBtn.remove(); xBtn = null; }
    if (lastTrigger) lastTrigger.classList.remove('jk-qa-hidden');
    var close = document.querySelector('.quick-add-sheet__close');
    if (close) close.classList.remove('jk-qa-hidden');
  }

  /* The card's "+" is copied into a floating button above the dim layer and
     the sheet, then travels to the sheet's close corner while it rotates into
     an "x" (same 0.18 s ease-out as the sheet). It replaces the sheet's own
     close button while the sheet is open, so there is exactly one "x". */
  function showX() {
    if (xBtn || !lastTrigger) return;
    var sheet = document.querySelector('.quick-add-sheet');
    var close = sheet && sheet.querySelector('.quick-add-sheet__close');
    var r = lastTrigger.getBoundingClientRect();
    if (!r.width || !sheet || !close) return;
    xBtn = document.createElement('button');
    xBtn.type = 'button';
    xBtn.className = 'jk-qa-x';
    xBtn.setAttribute('aria-label', 'Close quick add');
    xBtn.innerHTML = lastTrigger.innerHTML;
    xBtn.style.left = r.left + 'px';
    xBtn.style.top = r.top + 'px';
    xBtn.style.width = r.width + 'px';
    xBtn.style.height = r.height + 'px';
    xBtn.addEventListener('click', function () {
      if (window.QuickAddSheet && window.QuickAddSheet.close) window.QuickAddSheet.close();
      else hideX();
    });
    document.body.appendChild(xBtn);
    lastTrigger.classList.add('jk-qa-hidden');
    close.classList.add('jk-qa-hidden');
    /* Where the sheet's close button sits once the sheet has finished opening. */
    var sheetTop = window.innerHeight - sheet.offsetHeight;
    var tx = sheet.getBoundingClientRect().left + close.offsetLeft + (close.offsetWidth - r.width) / 2 - r.left;
    var ty = sheetTop + close.offsetTop + (close.offsetHeight - r.height) / 2 - r.top;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (!xBtn) return;
        xBtn.style.transform = 'translate(' + Math.round(tx) + 'px, ' + Math.round(ty) + 'px) rotate(45deg)';
        xBtn.classList.add('is-x');
      });
    });
  }

  function watchSheet() {
    var sheet = document.querySelector('.quick-add-sheet');
    if (!sheet || sheetObserver) return !!sheet;
    sheetObserver = new MutationObserver(function () {
      if (sheet.classList.contains('active')) showX(); else hideX();
    });
    sheetObserver.observe(sheet, { attributes: true, attributeFilter: ['class'] });
    return true;
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.quick-add-trigger');
    if (!t) return;
    lastTrigger = t;
    /* The sheet is built on first use by quick-add-sheet.js; start watching
       once it exists, then sync to its current state. */
    setTimeout(function () {
      if (watchSheet()) {
        var s = document.querySelector('.quick-add-sheet');
        if (s && s.classList.contains('active')) showX();
      }
    }, 0);
  }, true);

  /* 2. Continuous backdrop --------------------------------------------------- */
  var PARALLAX = 0.2; /* the picture drifts down 0.2 px per 1 px of scroll */
  var EXTEND = 24;    /* extra picture above the banner top and below the product area */

  function setupContinuous() {
    var banner = document.querySelector('[id$="__sale-countdown"] .jk-backdrop--linked');
    var page = document.querySelector('.thb-product-detail .jk-backdrop--linked');
    if (!banner || !page) return;
    var root = document.documentElement;

    function docTop(el) { return el.getBoundingClientRect().top + window.scrollY; }

    /* Values are written on the two layers only (never on <html>, which would
       restyle the whole page), and only when they change. */
    var last = {};
    function put(el, name, value) {
      var k = (el === banner ? 'b' : 'p') + name;
      if (last[k] === value) return;
      last[k] = value;
      el.style.setProperty(name, value);
    }
    function measure() {
      var y0 = docTop(banner);
      var pt = docTop(page);
      var pb = pt + page.offsetHeight;
      var imgTop = y0 - EXTEND;
      var h = Math.round((pb - y0) + 2 * EXTEND) + 'px';
      var w = root.clientWidth + 'px';
      var travel = Math.round(PARALLAX * Math.max(0, root.scrollHeight - window.innerHeight)) + 'px';
      [[banner, y0], [page, pt]].forEach(function (pair) {
        var el = pair[0];
        put(el, '--jk-c-h', h);
        put(el, '--jk-c-w', w);
        put(el, '--jk-c-travel', travel);
        put(el, '--jk-c-top', Math.round(imgTop - pair[1]) + 'px');
        put(el, '--jk-c-left', Math.round(-el.getBoundingClientRect().left) + 'px');
      });
    }

    measure();
    banner.classList.add('is-continuous');
    page.classList.add('is-continuous');
    var pending = false;
    var schedule = function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; measure(); });
    };
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('load', schedule);
    if ('ResizeObserver' in window) {
      /* The body is watched too: content that loads below the product area
         makes the page taller, which changes how far the picture must drift.
         put() above skips unchanged values, so this stays cheap. */
      var ro = new ResizeObserver(schedule);
      ro.observe(page);
      ro.observe(banner);
      ro.observe(document.body);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupContinuous, { once: true });
  else setupContinuous();

  /* 3. Mobile product gallery: stack at most 2 photos (Phase 1d) ---------------
     Photos 3+ of the selected colour/print group go into one swipe row under
     the first two (styles in assets/jackler-7x.css). Re-run after every
     variant change, because the visible group changes. Phones only. */
  var MAX_STACKED = 2;
  var mqPhone = window.matchMedia('(max-width: 767px)');

  function capGallery() {
    var sliders = document.querySelectorAll('.thb-product-detail .product-images.product-images--list');
    sliders.forEach(function (slider) {
      var slides = Array.prototype.slice.call(slider.querySelectorAll(':scope > .product-images__slide'));
      var extra = [];
      if (mqPhone.matches) {
        extra = slides.filter(function (s) { return getComputedStyle(s).display !== 'none'; }).slice(MAX_STACKED);
      }
      /* Only touch the DOM when something changes, so the observer below
         never feeds itself. */
      slides.forEach(function (s) {
        var want = extra.indexOf(s) !== -1;
        if (s.classList.contains('jk-gallery-extra') !== want) s.classList.toggle('jk-gallery-extra', want);
      });
      var n = String(Math.max(1, extra.length));
      if (slider.style.getPropertyValue('--jk-extra') !== n) slider.style.setProperty('--jk-extra', n);
      var capped = extra.length > 0;
      if (slider.classList.contains('jk-gallery-capped') !== capped) {
        slider.classList.toggle('jk-gallery-capped', capped);
        slider.scrollLeft = 0;
      }
    });
  }

  function initGalleryCap() {
    capGallery();
    var pending = false;
    var schedule = function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; capGallery(); });
    };
    /* The theme swaps the visible group by toggling is-active and moving the
       variant's photo to the front; watch for exactly that. */
    document.querySelectorAll('.thb-product-detail .product-images.product-images--list').forEach(function (slider) {
      new MutationObserver(function (list) {
        /* Only the slides' own changes matter, not lazy images loading inside them. */
        for (var i = 0; i < list.length; i++) {
          var m = list[i];
          if (m.type === 'childList' ? m.target === slider : m.target.parentElement === slider) { schedule(); return; }
        }
      }).observe(slider, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    });
    if (mqPhone.addEventListener) mqPhone.addEventListener('change', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initGalleryCap, { once: true });
  else initGalleryCap();

  /* 4. "Request a customization" link carries the selected variant (Phase 1e),
     so the form pre-fills the colour and size the shopper picked. The theme's
     variant event can carry the previous variant, so read the product form's
     own variant id once it has settled. */
  function syncRequestLink() {
    var id = document.querySelector('.thb-product-detail form[action*="/cart/add"] [name="id"]');
    if (!id || !id.value) return;
    document.querySelectorAll('a[data-jk-request-custom]').forEach(function (a) {
      try {
        var u = new URL(a.getAttribute('href'), location.origin);
        if (u.searchParams.get('variant') === id.value) return;
        u.searchParams.set('variant', id.value);
        a.setAttribute('href', u.pathname + u.search);
      } catch (err) {}
    });
  }
  document.addEventListener('product:variant-change', function () {
    setTimeout(syncRequestLink, 0);
    setTimeout(syncRequestLink, 400);
    setTimeout(syncRequestLink, 1200);
  });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('.thb-product-detail')) setTimeout(syncRequestLink, 50);
  });
  /* 5. Lean motion (7.12 lib round 5, Dan 2026-10-01). Reduced motion: none.
     a. Hub pages: each section that starts below the first screen rises in as it
        scrolls into view, once. Hub sections (ids with "hub_") fade without the
        rise: the listening station measures its table and has sticky parts.
     b. Collection and search grids: when a filter, sort or design pick swaps the
        cards, the cards on screen fade up in a quick cascade (12 at most). */
  var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!rm && window.IntersectionObserver && /\btemplate-page-[\w-]*hub\b/.test(document.body.className)) {
    // A first observer says where each section sits once the page has laid out: one on screen (even a sliver) is left
    // alone; one off screen is hidden (unseen, so no flash) and handed to a second observer that reveals it when it
    // is a little way into view.
    var rev = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var s = e.target; rev.unobserve(s);
        s.classList.add('is-in');
        setTimeout(function () { s.classList.remove('jk-rv', 'jk-rv--fade', 'is-in'); }, 900); // no lasting transform
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    var first = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var s = e.target; first.unobserve(s);
        if (e.isIntersecting || e.boundingClientRect.bottom < 0) return; // on screen, or already scrolled past
        s.classList.add('jk-rv');
        if (/hub_/.test(s.id)) s.classList.add('jk-rv--fade');
        rev.observe(s);
      });
    });
    document.querySelectorAll('#main-content > .shopify-section').forEach(function (s) { first.observe(s); });
  }
  var gridBox = document.getElementById('ProductGridContainer');
  if (!rm && gridBox && window.MutationObserver && Element.prototype.animate) {
    var fresh = new Set(), queued = false;
    var cascade = function () {
      queued = false;
      var n = 0, vh = window.innerHeight;
      fresh.forEach(function (li) {
        if (n >= 12 || !li.isConnected) return;
        var r = li.getBoundingClientRect();
        if (!r.width || r.bottom < 0 || r.top > vh) return;
        li.animate([{ opacity: 0, transform: 'translate3d(0, 14px, 0)' }, { opacity: 1, transform: 'none' }],
          { duration: 380, delay: n * 35, easing: 'cubic-bezier(.2, .7, .2, 1)', fill: 'backwards' });
        n++;
      });
      fresh.clear();
    };
    var take = function (li) { fresh.add(li); if (!queued) { queued = true; requestAnimationFrame(cascade); } };
    new MutationObserver(function (rs) {
      rs.forEach(function (r) {
        if (r.type === 'attributes') {
          var t = r.target;
          // a design pick shows or hides cards in place: every card left showing has moved, so all of them cascade
          if (t.parentNode && t.parentNode.id === 'product-grid' && /\bjk-dc-hidden\b/.test(r.oldValue || '') !== t.classList.contains('jk-dc-hidden')) {
            Array.prototype.forEach.call(t.parentNode.children, function (li) { if (li.tagName === 'LI' && !li.classList.contains('jk-dc-hidden')) take(li); });
          }
          return;
        }
        r.addedNodes.forEach(function (x) {
          if (x.nodeType !== 1) return;
          if (x.id === 'product-grid') Array.prototype.forEach.call(x.children, function (li) { if (li.tagName === 'LI') take(li); });
          else if (x.tagName === 'LI' && x.parentNode && x.parentNode.id === 'product-grid') take(x);
          else if (x.querySelector) { var g = x.querySelector('#product-grid'); if (g) Array.prototype.forEach.call(g.children, function (li) { if (li.tagName === 'LI') take(li); }); }
        });
      });
    }).observe(gridBox, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'], attributeOldValue: true });
  }
})();
